import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITION_SECRETARY_DELETE_REQUEST = 'DELETE_COMPETITION_SECRETARY_REQUEST';
export const COMPETITION_SECRETARY_DELETE_FAILURE = 'DELETE_COMPETITION_SECRETARY_FAILURE';
export const COMPETITION_SECRETARY_DELETE_SUCCESS = 'DELETE_COMPETITION_SECRETARY_SUCCESS';

export const deleteCompetitionSecretary = (id) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios(apiRequestOptions(apiPath.COMPETITION_SECRETARIES.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSuccess(id));
                dispatch(addSuccessMessage('Competition Secretary successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteRequest = () => {
    return {type: COMPETITION_SECRETARY_DELETE_REQUEST}
};
const deleteFailure = (error) => {
    return {type: COMPETITION_SECRETARY_DELETE_FAILURE, error}
};
const deleteSuccess = (competitionSecretary) => {
    return {type: COMPETITION_SECRETARY_DELETE_SUCCESS, competitionSecretary}
};